namespace GeniuzPOS.ReportMasterData {
    export interface Report_1601Form {
    }

    export class Report_1601Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1601';
    }
}
